export default "__VITE_ASSET__CYvXiS52__"